export default {"src":"/_next/static/media/rivieraFavicon.de01a35d.ico","height":32,"width":32,"blurWidth":0,"blurHeight":0};